import Config from "services/config/config";
import callWebService, { callTypes } from "services/utils/networks/network";
import {GET_ASSIGNED_TO, GET_REPORTEE, NEW_ASSIGNEE, SEARCH, UPLOAD_CSV} from "./type";

export const getReportee = (type) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        "",
        Config.BulkAssignment.repotee+"?type="+type
    );
    if (res) {
        const { data } = res;
        dispatch({ type: GET_REPORTEE, payload: data.response.data });
        return data.response.data;
    }
};

export const search = (filterData, type) => async (dispatch) => {
    let url = `${Config.BulkAssignment.search}?type=${type}`

    if(filterData !== null && filterData !== ""){
        url = `${Config.BulkAssignment.search}?site_no=${filterData.site_no ?? ""}&client_name=${filterData.client_name ?? ""}&site_type=${filterData.site_type ?? ""}&area_id=${filterData.area_id ?? ""}&commercial_type_id=${filterData.commercial_type_id ?? ""}&reporting_to=${filterData.reportingTo ?? ""}&reportee=${filterData.reportee ?? ""}&type=${type}`
        if(type === 1){
            url = `${Config.BulkAssignment.search}?site_no=${filterData?.site_no ?? ""}&client_name=${filterData?.client_name ?? ""}&site_type=${filterData?.site_type ?? ""}&assignee_ids=${filterData?.reportingTo ?? "" }&area_id=${filterData?.area_id ?? ""}&status_id=${filterData?.status_id ?? ""}&city_id=${filterData?.city_id ?? ""}&commercial_type_id=${filterData?.commercial_type_id ?? ""}&type=${type}`
        }
        if(type === 3){
            url = `${Config.BulkAssignment.search}?lead_id=${filterData?.leadID ?? ""}&status=${filterData?.leadStatus ?? ""}&client_name=${filterData?.clientNameOrPartnerName ?? ""}&created_on=${filterData?.createdOnDate ?? ""}&from_date=${filterData?.fromDate ?? ""}&to_date=${filterData?.toDate ?? ""}&assigned_to=${filterData?.leadOwnerOrAssignee ?? ""}&city=${filterData?.city ?? ""}&zone=${filterData?.zone ?? ""}&lead_cat=${filterData?.lead_cat ?? ""}&lcfrom_date=${filterData?.lcfromDate ?? ""}&lcto_date=${filterData?.lctoDate ?? ""}&ncfrom_date=${filterData?.ncfromDate ?? ""}&ncto_date=${filterData?.nctoDate ?? ""}&type=${type}`
        }
    }

    const res = await callWebService(
        callTypes.get,
        "",
        url
    );
    if (res) {
        const { data } = res;
        dispatch({ type: SEARCH, payload: data.response.data });
        return data.response.data;
    }
}

export const newAssignee = (data) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post,
        data,
        Config.BulkAssignment.newAssignee
    );
    if (res) {
        const { data } = res;
        dispatch({ type: NEW_ASSIGNEE, payload: data });
        return data;
    }
};

export const uploadcsvfile = (file, type_activity) => async (dispatch) => {
    
    const formData = new FormData();
    formData.append("csv_file", file);
    formData.append("type_activity", type_activity);

    const config = {
        headers: {
        "Content-Type": "multipart/form-data",
        },
    };

    const res = await callWebService(
        callTypes.post,
        formData,
        Config.BulkAssignment.uploadcsvfile,
        config
    );
    if (res) {
        const { data } = res;
        dispatch({ type: UPLOAD_CSV, payload: data });
        return data;
    }
};